import { Pin } from '@vis.gl/react-google-maps'

export const SelectedPhamarcyPin = (): JSX.Element => (
  <Pin
    background='#22ccff'
    borderColor='#1e89a1'
    glyphColor='#0f677a'
  />
)
